module.exports = __webpack_public_path__ + "img/in.75105d58.svg";